import React, { useEffect, useState } from 'react'
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select,
} from '@mui/material'
import { useQuery } from '@apollo/client'
import {
  Button,
  Grid,
  IconButton,
  makeStyles,
  Tooltip,
  Zoom,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { COLORS } from 'src/utils/Themes/colors'
import groupTermInsurance from 'src/assets/link_annexure/groupTermInsurance.svg'
import groupAccidentalInsurance from 'src/assets/link_annexure/groupAccidentalInsurance.svg'
import GroupHealthInsurance from 'src/assets/link_annexure/GroupHealthInsurance.svg'
import DownloadIcon from '@mui/icons-material/Download'
import { useParams } from 'react-router-dom'
import { LINK_ANNEXURE } from 'src/services/corporateService'
import {
  getClientId,
  getClientType,
  getClientTypeUrl,
} from 'src/utils/commonMethods'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import CloseButton from 'src/components/common/CloseButton'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import { invokeAllTypesSXP } from 'src/services/individualService'
import {
  ADD_DEPENDENTS,
  BRANCH_BASED,
  DOWNLOAD_POLICY,
  MULTI_SELECT_INFO,
  PER_CATEGORY_TXT,
} from 'src/utils/constants/Ceo'
import {
  ENDORSEMENT_TYPE,
  IS_ADD,
} from 'src/utils/constants/EmployeeManagement'

const AddEmployeeModal = ({
  closeFunction,
  dataLocation,
  annexureType,
  clientDetails,
  isCompanyPolicy = false,
  action,
}) => {
  const classes = useStyles()

  const userInfo = useSelector((state) => state?.userInfo)
  const [submitOpen, setSubmitOpen] = React.useState(false)
  const [location, setLocation] = useState('')
  const [branch, setBranch] = useState('')
  const [branchList, setBranchList] = useState([])
  const [gmc, setGmc] = React.useState([])
  const [gtl, setGtl] = React.useState([])
  const [gpa, setGpa] = React.useState([])
  const [gmcPolicyList, setGmcPolicyList] = React.useState([])
  const [gtlPolicyList, setGtlPolicyList] = React.useState([])
  const [gpaPolicyList, setGpaPolicyList] = React.useState([])
  const [skipRefetch, setSkipRefetch] = useState(true)
  const filterType = BRANCH_BASED
  const params = useParams()

  const { data, refetch } = useQuery(
    LINK_ANNEXURE(
      getClientId(params?.clientId, userInfo),
      filterType,
      location,
      branch
    ),
    { skip: skipRefetch }
  )

  useEffect(() => {
    if (dataLocation?.length > 0) {
      setLocation(dataLocation?.[0]?.locationName)
      setBranchList(dataLocation?.[0]?.branchNames)
      setGmcPolicyList(dataLocation?.[0]?.policyData?.gmcPolicies)
      setGpaPolicyList(dataLocation?.[0]?.policyData?.gpaPolicies)
      setGtlPolicyList(dataLocation?.[0]?.policyData?.gtlPolicies)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (data) {
      if (data?.getAnnexurePolicyDetails?.branchData !== null) {
        setGmcPolicyList(
          data?.getAnnexurePolicyDetails?.branchData?.policyData?.gmcPolicies
        )
        setGtlPolicyList(
          data?.getAnnexurePolicyDetails?.branchData?.policyData?.gtlPolicies
        )
        setGpaPolicyList(
          data?.getAnnexurePolicyDetails?.branchData?.policyData?.gpaPolicies
        )
      }
    }
    // eslint-disable-next-line
  }, [data])

  useEffect(() => {
    if (!skipRefetch) {
      refetch()
    }
    // eslint-disable-next-line
  }, [skipRefetch])

  const locationMap = new Map()
  dataLocation?.forEach((object) => {
    locationMap.set(object?.locationName, object)
  })
  let locationArray1 = Array.from(locationMap.keys())

  const handleChangeGMC = (event) => {
    const index = gmc?.indexOf(event?.target?.value)
    if (index === -1) {
      setGmc([...gmc, event?.target?.value])
    } else {
      setGmc(gmc?.filter((gmcListItem) => gmcListItem !== event?.target?.value))
    }
  }
  const gmcError = gmc?.length > 1

  const handleChangeGTL = (event) => {
    const index = gtl?.indexOf(event?.target?.value)
    if (index === -1) {
      setGtl([...gtl, event?.target?.value])
    } else {
      setGtl(gtl?.filter((gtlListItem) => gtlListItem !== event?.target?.value))
    }
  }
  const gtlError = gtl?.length > 1

  const handleChangeGPA = (event) => {
    const index = gpa?.indexOf(event?.target?.value)

    if (index === -1) {
      setGpa([...gpa, event?.target?.value])
    } else {
      setGpa(gpa?.filter((gpaListItem) => gpaListItem !== event?.target?.value))
    }
  }
  const gpaError = gpa?.length > 1
  const handleLocationChange = (event) => {
    setLocation(event?.target?.value)
    let locMapValue = locationMap.get(event?.target?.value)
    setBranchList(locMapValue?.branchNames)
    setBranch('')
    setGmcPolicyList(locMapValue?.policyData?.gmcPolicies)
    setGtlPolicyList(locMapValue?.policyData?.gtlPolicies)
    setGpaPolicyList(locMapValue?.policyData?.gpaPolicies)
    setSkipRefetch(true)
  }
  const handleBranchChange = (event) => {
    setBranch(event?.target?.value)
    setSkipRefetch(false)
  }

  const handleClose = () => {
    setSubmitOpen(false)
  }

  const handleSubmit = () => {
    if (annexureType === ADD_DEPENDENTS) {
      if (gmc?.length > 1 || gmc?.length === 0) {
        setSubmitOpen(true)
      } else {
        invokeSxpSingleAnnexureClose(annexureType)
      }
    } else {
      if (
        gmc?.length > 1 ||
        gtl?.length > 1 ||
        gpa?.length > 1 ||
        (gmc?.length === 0 && gtl?.length === 0 && gpa?.length === 0)
      ) {
        setSubmitOpen(true)
      } else {
        invokeSxpSingleAnnexureClose(annexureType)
      }
    }
  }

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  const invokeSxpSingleAnnexureClose = (type, editUserData) => {
    const sxpBody1 = {
      state: {
        clientId: getClientId(params?.clientId, userInfo),
        clientType: getClientType(params?.clientType, userInfo),
        clientStatus: clientDetails?.clientStatus,
        createdBy: userInfo?.userName,
        updatedBy: userInfo?.userName,
        email: userInfo?.userInfo?.userData?.emailId,
        roles: userInfo?.userInfo?.userData?.roles,
        linkGMC: gmc,
        linkGTL: gtl,
        linkGPA: gpa,
        editUserData: editUserData,
        isCompanyPolicy: isCompanyPolicy,
        clientTypeUrl: getClientTypeUrl(
          getClientType(params?.clientType, userInfo)
        ),
        url: getUrl(),
        endorsementType:
          action === IS_ADD ? ENDORSEMENT_TYPE?.ADD : ENDORSEMENT_TYPE?.UPDATE,
      },
      userId: userInfo?.userName,
    }
    invokeAllTypesSXP(sxpBody1, userInfo?.userName, type)
  }

  const getUrl = () => {
    return 'dashboard/company/employeeManagement'
  }

  const policyCard = (item, id) => {
    return (
      <div className={classes.policyCardContainer}>
        <img
          src={item?.provider?.image}
          className={classes.providerImage}
          alt=''
        />
        <div className={classes.labelContainer}>
          <span className={classes.labelProvider}>{item?.provider?.name}</span>

          <div className={classes.policyCardContainer}>
            <span className={classes.labelPolicy}>Id : {item?.id}</span>
            <Tooltip
              TransitionComponent={Zoom}
              placement='top'
              title={DOWNLOAD_POLICY}
              arrow
            >
              <IconButton
                id={id}
                size='small'
                onClick={() =>
                  handleDocumentDownload(
                    item?.policyDocument,
                    item?.policyDocumentURL
                  )
                }
              >
                <DownloadIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.containerDiv}>
      <CloseButton
        id='closeButton'
        title='Close'
        handleClose={closeFunction}
        classname={classes.clsBtn}
      />
      <div className={classes.selectLocationHeading}>
        <p data-test='modal-heading'>Select the Location & Policy type</p>
      </div>

      <div className={classes.selectDiv}>
        <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
          <Grid item xs={12} md={6}>
            <div className={classes.selectLocationDiv} data-test='location-div'>
              <h6 className={classes.selectCityHeading}>
                Select City<span className={classes.selectCityStyle}>*</span>
              </h6>
              <FormControl
                id='location-control'
                className={`${classes.formControlStyle} ${classes.formFieldContainer}`}
              >
                <Select
                  id='locationSelect'
                  name='location'
                  value={location}
                  onChange={handleLocationChange}
                  defaultValue={location}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  autowidth
                  className={classes.locationSelectControl}
                >
                  {locationArray1?.map((item) => (
                    <MenuItem key={`location_${item}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.selectBranchDiv} data-test='branch-div'>
              <h6
                style={{
                  color: branchList?.length === 0 ? '#5F5F5F' : '#141414',
                  marginLeft: '7px',
                }}
              >
                Select Branch<span className={classes.selectCityStyle}>*</span>
              </h6>
              <FormControl
                className={`${classes.formControlStyle} ${classes.formFieldContainer}`}
                id='branch-control'
                disabled={branchList?.length === 0 ? true : false}
              >
                <Select
                  id='branchSelect'
                  value={branch}
                  placeholder={'Select Branch'}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  onChange={(event) => {
                    handleBranchChange(event)
                  }}
                  className={classes.locationSelectControl}
                >
                  {branchList?.map((item) => (
                    <MenuItem key={`branch_${item}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.addDependentsTexts}>
        {annexureType === ADD_DEPENDENTS ? null : MULTI_SELECT_INFO}
      </div>

      <div className={classes.insuranceTypeDiv}>
        {annexureType === ADD_DEPENDENTS ? (
          <Grid container alignItems='center' justifyContent='center'>
            <Grid
              item
              xs={12}
              md={gmcPolicyList?.length > 0 ? 4 : 12}
              data-test='gmc-insurance-div'
            >
              <div className={classes.policyRadioButton}>
                <FormControl error={gmcError} fullWidth>
                  <FormLabel
                    id='controlled-radio-buttons-gmc'
                    className={classes.policyFormControl}
                  >
                    <img
                      className={classes.insuranceImage}
                      src={GroupHealthInsurance}
                      alt='Group Health Insurance'
                    />
                    Group Health Insurance
                  </FormLabel>
                  <FormGroup className={classes.formGroupStyle}>
                    {gmcPolicyList?.length > 0 ? (
                      gmcPolicyList?.map((item) => (
                        <FormControlLabel
                          key={`dependentsGmc__${item.id}`}
                          labelPlacement='start'
                          label={policyCard(item, 'addDependentsGmcDownload')}
                          value={item?.id}
                          control={
                            <Checkbox
                              id='gmcPolicy'
                              checked={gmc?.includes(item?.id)}
                              onClick={handleChangeGMC}
                            />
                          }
                          className={classes.formControlLabelStyle}
                        />
                      ))
                    ) : (
                      <div className={classes.labelContainer}>
                        <p className={classes.labelNoRelatedPolicy}>
                          No Related Policies
                        </p>
                      </div>
                    )}
                  </FormGroup>
                  <FormHelperText whiteSpace={'nowrap'}>
                    {gmcPolicyList?.length > 0 ? PER_CATEGORY_TXT : null}
                  </FormHelperText>
                </FormControl>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} md={4} data-test='gmc-insurance-div'>
              <div className={classes.policyRadioButton}>
                <FormControl error={gmcError} fullWidth>
                  <FormLabel
                    id='controlled-radio-buttons-gmc'
                    className={classes.policyFormControl}
                  >
                    <img
                      className={classes.insuranceImage}
                      src={GroupHealthInsurance}
                      alt='Group Health Insurance'
                    />
                    Group Health Insurance
                  </FormLabel>
                  <FormGroup className={classes.formGroupStyle}>
                    {gmcPolicyList?.length > 0 ? (
                      gmcPolicyList?.map((item) => (
                        <FormControlLabel
                          key={`gmc__${item?.id}`}
                          labelPlacement='start'
                          label={policyCard(item, 'download-annexure-policy')}
                          value={item?.id}
                          control={
                            <Checkbox
                              id='gmcPolicy'
                              checked={gmc?.includes(item?.id)}
                              onClick={handleChangeGMC}
                            />
                          }
                          className={classes.formControlLabelStyle}
                        />
                      ))
                    ) : (
                      <div className={classes.labelContainer}>
                        <p className={classes.labelNoRelatedPolicy}>
                          No Related Policies
                        </p>
                      </div>
                    )}
                  </FormGroup>
                  <FormHelperText whiteSpace={'nowrap'}>
                    {gmcPolicyList?.length > 0 ? PER_CATEGORY_TXT : null}
                  </FormHelperText>
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={12} md={4} data-test='gtl-insurance-div'>
              <div className={classes.policyRadioButton}>
                <FormControl error={gtlError} fullWidth>
                  <FormLabel
                    id='controlled-radio-buttons-gtl'
                    className={classes.policyFormControl}
                  >
                    <img
                      className={classes.insuranceImage}
                      src={groupTermInsurance}
                      alt='Group Term Insurance'
                    />
                    {INSURANCE_NAMES?.GROUP_TERM_INSURANCE}
                  </FormLabel>
                  <FormGroup className={classes.formGroupStyle}>
                    {gtlPolicyList?.length > 0 ? (
                      gtlPolicyList?.map((item) => (
                        <FormControlLabel
                          key={`gtl__${item?.id}`}
                          labelPlacement='start'
                          label={policyCard(item, 'gtlPolicyDownload')}
                          value={item?.id}
                          control={
                            <Checkbox
                              id='gtlPolicy'
                              checked={gtl?.includes(item?.id)}
                              onClick={handleChangeGTL}
                            />
                          }
                          className={classes.formControlLabelStyle}
                        />
                      ))
                    ) : (
                      <div className={classes.labelContainer}>
                        <p className={classes.labelNoRelatedPolicy}>
                          No Related Policies
                        </p>
                      </div>
                    )}
                  </FormGroup>
                  <FormHelperText whiteSpace={'nowrap'}>
                    {gtlPolicyList?.length > 0 ? PER_CATEGORY_TXT : null}
                  </FormHelperText>
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={12} md={4} data-test='gpa-insurance-div'>
              <div className={classes.policyRadioButton}>
                <FormControl error={gpaError} fullWidth>
                  <FormLabel
                    id='controlled-radio-buttons-gpa'
                    className={classes.policyFormControl}
                  >
                    <img
                      className={classes.insuranceImage}
                      src={groupAccidentalInsurance}
                      alt='Group Accidental Insurance'
                    />
                    Group Accident Insurance
                  </FormLabel>
                  <FormGroup className={classes.formGroupStyle}>
                    {gpaPolicyList?.length > 0 ? (
                      gpaPolicyList?.map((item) => (
                        <FormControlLabel
                          key={`gpa__${item?.id}`}
                          labelPlacement='start'
                          label={policyCard(item, 'gpaPolicyDownload')}
                          value={item?.id}
                          control={
                            <Checkbox
                              id='gpaPolicy'
                              checked={gpa?.includes(item?.id)}
                              onClick={handleChangeGPA}
                            />
                          }
                          className={classes.formControlLabelStyle}
                        />
                      ))
                    ) : (
                      <div className={classes.labelContainer}>
                        <p className={classes.labelNoRelatedPolicy}>
                          No Related Policies
                        </p>
                      </div>
                    )}
                  </FormGroup>
                  <FormHelperText whiteSpace={'nowrap'}>
                    {gpaPolicyList?.length > 0 ? PER_CATEGORY_TXT : null}
                  </FormHelperText>
                </FormControl>
              </div>
            </Grid>
          </Grid>
        )}
      </div>
      <Button
        id='submitButton'
        variant='contained'
        className={classes.submitButton}
        onClick={handleSubmit}
      >
        Submit
      </Button>

      <Dialog
        open={submitOpen}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Please select atleast one policy to continue
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id='dialogCloseButton' onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default AddEmployeeModal
const useStyles = makeStyles({
  containerDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px',
    overflowY: 'scroll',
    height: '500px',
  },
  selectDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px',
    marginTop: '-8px',
  },
  selectLocationDiv: {
    display: 'flex',
    flexDirection: 'column',
  },
  selectBranchDiv: {
    display: 'flex',
    flexDirection: 'column',
  },
  clsBtn: {
    position: 'absolute',
    right: '10px',
    top: '10px',
  },
  policyRadioButton: {
    width: '100%',
    height: '290px',
    marginTop: '-20px',
    border: '1px solid #D2D2D2',
    marginRight: '10px',
  },
  insuranceTypeDiv: {
    padding: '20px',
    width: '90%',
  },
  logoPic: {
    width: '30px',
    height: '30px',
  },
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.MEDIUM_LIGHTBLUE,
    color: COLORS.WHITE,
    margin: '-4px 0 10px 9px',
    height: '24px',
    padding: '17px 15px !important',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_LIGHTBLUE,
    },
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '5px',
    paddingRight: '5px',
  },
  submitButton: {
    width: '126px',
    height: '36px',
    background: '#B92250',
    color: 'white',
    '&:hover': {
      backgroundColor: COLORS.DARK_PINK,
    },
  },
  labelProvider: {
    fontSize: '14px',
    fontWeight: '600',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    color: '#000000',
    lineHeight: '18px',
  },
  labelPolicy: {
    fontSize: '11px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    color: '#000000',
  },
  formFieldContainer: {
    minWidth: 120,
    margin: 1,
  },
  labelNoRelatedPolicy: {
    display: 'flex',
    fontSize: '12px',
    width: '100%',
    fontWeight: '600',
    color: '#B92250',
    whiteSpace: 'nowrap',
    marginTop: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '50%',
  },
  formControlLabelStyle: {
    background: 'linear-gradient(180deg, #FFFFFF 0%, #EBEBEB 100%)',
    width: '80%',
    border: '1px solid #CDCDCD',
  },
  formGroupStyle: {
    borderTop: '1px solid #A9A9A9',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: '290px',
    height: '200px',
    overflowY: 'scroll !important',
    paddingTop: '10px',
    paddingLeft: '15px',
  },
  labelComponentStyle: {
    fontWeight: '600',
    fontSize: '17px',
    whiteSpace: 'nowrap',
    color: '#B92250',
    borderBottom: '1px solid #A9A9A9',
  },
  selectLocationHeading: {
    color: '#333333',
    fontSize: '23px',
  },
  selectCityHeading: {
    color: '#141414',
    marginLeft: '7px',
  },
  selectCityStyle: {
    color: '#B92250',
  },
  locationSelectControl: {
    padding: '0px 10px',
    width: '220px',
    height: '30px',
    border: '1px solid #C6C6C6',
  },
  formControlStyle: {
    marginTop: '-3px',
  },
  addDependentsText: {
    fontSize: '15px',
    color: '#5A5A5A',
    fontWeight: '400',
    textAlign: 'center',
    marginTop: '-5px',
    marginBottom: '10px',
  },
  policyFormControl: {
    fontWeight: '600',
    fontSize: '17px',
    whiteSpace: 'nowrap',
    color: '#B92250',
    padding: '5px',
  },
  insuranceImage: {
    width: '37px',
    height: '35px',
  },
  policyCardContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  providerImage: {
    width: '10%',
    height: '30px',
  },
})
